import { render } from "./StockRegisterTable.backup.vue?vue&type=template&id=4180da2a&scoped=true"
import script from "./StockRegisterTable.backup.vue?vue&type=script&lang=js"
export * from "./StockRegisterTable.backup.vue?vue&type=script&lang=js"

import "./StockRegisterTable.backup.vue?vue&type=style&index=0&id=4180da2a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4180da2a"]])

export default __exports__